module.exports = __webpack_public_path__ + "static/mouad-326e2cbd1c919289665cfd26e2059055.jpg";